(function($) {
  
    $(document).ready(function() {
        
    });
  
})(jQuery);

function initProfileFormPage(){
    var $ = jQuery;
    /*$('.typerocket-elements-fields-select select').multipleSelect({
        single:true,
        placeholder: objectL10n.placeholder,
        noMatchesFound : objectL10n.noMatchesFound,
        filter: true,
        selectAll: false,
        formatCountSelected: '# '+objectL10n.choix,
        //isOpen: true,
        //keepOpen: true
        onClick: function(view) {
            $('.m-searchform-archive select').each(function(){
                //console.log($(this).multipleSelect('getSelects').length);
                if($(this).multipleSelect('getSelects').length){
                    $(this).parent().find('.ms-parent .ms-choice div').html('<div class="count">'+$(this).multipleSelect('getSelects').length+'</div>')
                }else{
                    $(this).parent().find('.ms-parent .ms-choice div').html('')
                }
            })
        },
        onFocus: function(view){
            $(this).parent().removeClass('is-open');
        },
        onBlur: function(view){
            $(this).parent().addClass('is-open');
        }
    });*/
}